.bar {
    width: 100%;
    overflow: hidden;
    flex-grow: 1;
}
